module.exports = {"140311100":"荫营镇","140311101":"河底镇","140311103":"平坦镇","140311200":"西南舁乡","140311201":"杨家庄乡","140311202":"李家庄乡","140311203":"旧街乡","140311400":"开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140311.json
// module id = 374
// module chunks = 0